import React, { Component } from "react";
import Link from "gatsby-link";
import Img from "gatsby-image";
import QuickSearch from "../components/QuickSearch";
import FaHome from 'react-icons/lib/fa/home';
import FaLinkedIn from 'react-icons/lib/fa/linkedin';
import FaFacebook from 'react-icons/lib/fa/facebook';
import FaTwitter from 'react-icons/lib/fa/twitter';
import FaGithub from 'react-icons/lib/fa/github';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

const Header = props => (
    <header
        id="masthead"
        className="site-header has-header-image"
        role="banner"
    >
        <div className="site-title-centered">
            <div className="header-image">
                <Img sizes={props.data.contentfulSiteSettings.headingImage.sizes}
                    style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%"
                    }} />
                <div className="header-image-container">
                    <div className="site-branding">
                    <h1 className="site-title">
                        <Link to="/">TônNguyễn</Link>
                    </h1>
                    </div>
                </div>
            </div>
            <div className="main-navbar">
                <div className="container">
                    <div className="main-navbar__quick-search">
                        <Link to="/"><FaHome /></Link>
                        <OutboundLink href="https://www.linkedin.com/in/tonnguyen/" title="Find Ton Nguyen on LinkedIn" aria-label="Find Ton Nguyen on LinkedIn"><FaLinkedIn /></OutboundLink>
                        <OutboundLink href="https://github.com/tonnguyen" title="Find Ton Nguyen on GitHub" aria-label="Find Ton Nguyen on GitHub"><FaGithub /></OutboundLink>
                        <OutboundLink href="https://twitter.com/bobrowley" title="Find Ton Nguyen on Twitter" aria-label="Find Ton Nguyen on Twitter"><FaTwitter /></OutboundLink>
                        <OutboundLink href="https://www.facebook.com/ton.nguyen.hoang" title="Find Ton Nguyen on Facebook" aria-label="Find Ton Nguyen on Facebook"><FaFacebook /></OutboundLink>
                        <QuickSearch {...props} />
                    </div>
                </div>
            </div>
        </div>
    </header>
);

export default Header;


// WEBPACK FOOTER //
// ./src/layouts/header.js